export default __webpack_public_path__ + "static/media/Group 823.e5bb9ef0.png";